import { useEffect, useState } from "react";
import { getUser } from "../auth-provider";
import { KeycloakRole } from "../api";

export type UseRoleGuardProps = {
    roles: KeycloakRole[];
};

/**
 * Returns whether the use has at least one of the given roles.
 *
 * ATTENTION: Since requesting the user roles is asynchronous, this hook may return `false` on first rendering.
 *
 * @see RoleGuard
 */
export const useRoleGuard = ({ roles }: UseRoleGuardProps): boolean => {
    const [hasRoles, setHasRoles] = useState(false);
    useEffect(() => {
        const checkRoles = async () => {
            const user = await getUser();
            if (user) {
                const userHasRoles = user.keycloakRoles?.some((role) => roles.includes(role as KeycloakRole)) || false;
                setHasRoles(userHasRoles);
            } else {
                setHasRoles(false);
            }
        };
        checkRoles().then();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return hasRoles;
};
